import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import MultiSelect from '@components/form/MultiSelect';
import Select from '@components/form/Select';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import useSite from 'lib/src/hooks/useSite';
import { site as siteEnum } from 'lib/src/shared/enums/site';
import { DropdownOption } from 'lib/src/types/shared/DropdownOption';
import useCreateChallengeGroup from './hooks/useCreateChallengeGroup';

const CreateChallengeGroupModal = () => {
    const {
        handleSubmit,
        handleChange,
        closeModal,
        isPosting,
        formState: { name, adminIDs, viewerIDs, site },
        adminOptions,
        viewerOptions,
    } = useCreateChallengeGroup();

    const userSite = useSite();
    const siteOptions: DropdownOption<siteEnum>[] = [
        { label: 'IX', value: siteEnum.IX },
        { label: 'GA', value: siteEnum.GA },
    ];

    return (
        <Modal title="Create Challenge Group" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        name="name"
                        value={name}
                        onChange={handleChange}
                        label="Name"
                        placeholder="Name of this Challenge Group"
                        required
                    />
                </FormRow>

                <FormRow>
                    <MultiSelect
                        name="adminIDs"
                        value={adminIDs}
                        onChange={handleChange}
                        label="Admins"
                        options={adminOptions}
                        search
                    />
                    <MultiSelect
                        name="viewerIDs"
                        value={viewerIDs}
                        onChange={handleChange}
                        label="Viewers"
                        options={viewerOptions}
                        search
                    />
                    {userSite === siteEnum.ALL && (
                        <Select
                            name="site"
                            value={site}
                            onChange={handleChange}
                            label="Site"
                            options={siteOptions}
                            canBeEmpty={false}
                            required
                        />
                    )}
                </FormRow>
            </Form>
        </Modal>
    );
};

export default CreateChallengeGroupModal;
